import React from "react";
import "./ModalV2Buttons.sass";

export default function ModalV2Buttons({
  onCancel,
  onConfirm,
  cancelText = "Cancel",
  confirmText = "Continue",
  cancelDisabled = false,
  confirmDisabled = false,
  confirmLoading = false,
  variant = "primary",
}) {
  return (
    <div className="ModalV2Buttons">
      <button
        type="button"
        className="ModalV2Buttons__btn ModalV2Buttons__btn--cancel"
        onClick={onCancel}
        disabled={cancelDisabled}
      >
        {cancelText}
      </button>

      <button
        type="button"
        className={`ModalV2Buttons__btn ModalV2Buttons__btn--${variant}`}
        onClick={onConfirm}
        disabled={confirmDisabled || confirmLoading}
      >
        {confirmLoading ? "Loading..." : confirmText}
      </button>
    </div>
  );
}
